/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContractSummary } from './ContractSummary';
import {
    ContractSummaryFromJSON,
    ContractSummaryFromJSONTyped,
    ContractSummaryToJSON,
} from './ContractSummary';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
} from './InsurancePayor';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
} from './ReimbursementType';
import type { TimReportResult } from './TimReportResult';
import {
    TimReportResultFromJSON,
    TimReportResultFromJSONTyped,
    TimReportResultToJSON,
} from './TimReportResult';
import type { TimVisualReference } from './TimVisualReference';
import {
    TimVisualReferenceFromJSON,
    TimVisualReferenceFromJSONTyped,
    TimVisualReferenceToJSON,
} from './TimVisualReference';

/**
 * 
 * @export
 * @interface TimExecution
 */
export interface TimExecution {
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    insurance_type: TimExecutionInsuranceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    state: TimExecutionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    report?: string;
    /**
     * 
     * @type {Array<TimVisualReference>}
     * @memberof TimExecution
     */
    visual_references?: Array<TimVisualReference>;
    /**
     * 
     * @type {TimReportResult}
     * @memberof TimExecution
     */
    report_result: TimReportResult;
    /**
     * 
     * @type {string}
     * @memberof TimExecution
     */
    created_at: string;
    /**
     * 
     * @type {ReimbursementType}
     * @memberof TimExecution
     */
    reimbursement_type?: ReimbursementType;
    /**
     * ISO timestamp of when the TIM execution finished
     * @type {string}
     * @memberof TimExecution
     */
    finished_at?: string;
    /**
     * 
     * @type {InsurancePayor}
     * @memberof TimExecution
     */
    payor?: InsurancePayor;
    /**
     * 
     * @type {ContractSummary}
     * @memberof TimExecution
     */
    contract?: ContractSummary;
}


/**
 * @export
 */
export const TimExecutionInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay'
} as const;
export type TimExecutionInsuranceTypeEnum = typeof TimExecutionInsuranceTypeEnum[keyof typeof TimExecutionInsuranceTypeEnum];

/**
 * @export
 */
export const TimExecutionStateEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Finished: 'finished'
} as const;
export type TimExecutionStateEnum = typeof TimExecutionStateEnum[keyof typeof TimExecutionStateEnum];


/**
 * Check if a given object implements the TimExecution interface.
 */
export function instanceOfTimExecution(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "insurance_type" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "report_result" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function TimExecutionFromJSON(json: any): TimExecution {
    return TimExecutionFromJSONTyped(json, false);
}

export function TimExecutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimExecution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'payor_id': json['payor_id'],
        'insurance_type': json['insurance_type'],
        'state': json['state'],
        'report': !exists(json, 'report') ? undefined : json['report'],
        'visual_references': !exists(json, 'visual_references') ? undefined : ((json['visual_references'] as Array<any>).map(TimVisualReferenceFromJSON)),
        'report_result': TimReportResultFromJSON(json['report_result']),
        'created_at': json['created_at'],
        'reimbursement_type': !exists(json, 'reimbursement_type') ? undefined : ReimbursementTypeFromJSON(json['reimbursement_type']),
        'finished_at': !exists(json, 'finished_at') ? undefined : json['finished_at'],
        'payor': !exists(json, 'payor') ? undefined : InsurancePayorFromJSON(json['payor']),
        'contract': !exists(json, 'contract') ? undefined : ContractSummaryFromJSON(json['contract']),
    };
}

export function TimExecutionToJSON(value?: TimExecution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'payor_id': value.payor_id,
        'insurance_type': value.insurance_type,
        'state': value.state,
        'report': value.report,
        'visual_references': value.visual_references === undefined ? undefined : ((value.visual_references as Array<any>).map(TimVisualReferenceToJSON)),
        'report_result': TimReportResultToJSON(value.report_result),
        'created_at': value.created_at,
        'reimbursement_type': ReimbursementTypeToJSON(value.reimbursement_type),
        'finished_at': value.finished_at,
        'payor': InsurancePayorToJSON(value.payor),
        'contract': ContractSummaryToJSON(value.contract),
    };
}

